import { StudioApplication } from './studioApplication';
import { Templates } from '../compile';
import { InvalidLicenseReason } from 'mappClient/enums';
import { Event, Util } from 'mappMvc/models';
import { IEvent } from 'mappMvc/interfaces';
import { IToken } from 'mappClient/token';
import { MetadataClient } from 'mappClient/metadataClient';
import * as _ from 'underscore';
import { KoExtensions } from 'mappMvc/extensions/ko/observable';
import { Localization } from 'mappMvc/compile';
import { ApplicationConfig } from 'mappMvc/const';

export class LoginUser {
	private fullName: KnockoutComputed<string>;
	private template: KnockoutObservable<string>;
	private imageSrc: KnockoutObservable<string>;
	private isLoggedIn: KnockoutObservable<boolean>;
	public email: KnockoutObservable<string>;
	public userName: KnockoutObservable<string>;
	public userLanguage: KnockoutObservable<string>;
	public accountName: KnockoutObservable<string>;
    public isActiveDirectory: KnockoutObservable<boolean>;
    public isFusionServerEnabled: KnockoutObservable<boolean>;
    public hasProLicense: KnockoutObservable<boolean>;
		public isManagementUser: KnockoutObservable<boolean>;
		public isTwoFactorAuthenticated: KnockoutObservable<boolean>;

	private help: () => void;
	public logout: () => void;
	private settings: () => void;
	private studio: StudioApplication;
	private _fullName: string;
	public userId: string;
	private invalidLicenseReason: InvalidLicenseReason;
	public settingsVisible: boolean;

	private mouseTimestamp: number;
	private mouseDown: () => void;
	private mouseUp: () => void;

	public get InvalidAccount(): boolean {
		return this.invalidLicenseReason == InvalidLicenseReason.InvalidAccount;
	}

	public get ServiceDown(): boolean {
		return this.invalidLicenseReason == InvalidLicenseReason.ServiceDown;
	}

	private onSettingsClick: Event<void>;
	public get SettingsClicked(): IEvent<void> {
		return this.onSettingsClick;
	}

	private onLogoutClick: Event<void>;
	public get LogoutClicked(): IEvent<void> {
		return this.onLogoutClick;
	}

	public constructor(studio: StudioApplication) {
		this.template = ko.observable(Templates.header_user);

		this.studio = studio;
		this.isLoggedIn = ko.observable(false);
		this.imageSrc = KoExtensions.observable<string>();
		this.invalidLicenseReason = InvalidLicenseReason.None;
		this.email = KoExtensions.observable<string>();
		this.userName = KoExtensions.observable<string>();
		this.userLanguage = ko.observable<string>();
		this.accountName = KoExtensions.observable<string>();
		this.userId = null;
		this.isTwoFactorAuthenticated = KoExtensions.observable<boolean>(false);
		this.settingsVisible = true;
		this.onSettingsClick = new Event<void>();
		this.onLogoutClick = new Event<void>();
        this.isActiveDirectory = ko.observable<boolean>(false);
        this.isFusionServerEnabled = ko.observable<boolean>(false);
        this.isManagementUser = ko.observable<boolean>(false);
        this.hasProLicense = ko.observable<boolean>(false);

		this.fullName = ko.pureComputed(() => {
			return this.isLoggedIn() ? this._fullName : Localization.Login.Guest;
		});

		this.logout = () => {
			this.onLogoutClick.notify();
			Util.StudioNotification.close();
			MetadataClient.logout();
			this.studio.forceLogIn();
		};
		this.settings = () => {
			this.onSettingsClick.notify();
		};

		this.mouseDown = () => {
			this.mouseTimestamp = new Date().getTime();
		};

		this.mouseUp = () => {
			if (new Date().getTime() - this.mouseTimestamp > 3000) {
				$('body').toggleClass('high-contrast');
			}
		};
	}

	public updateUserInfo(): boolean {
		//TODO: defined name or fullname as welcome textasdf
		this.isLoggedIn(false);

		var token: IToken = MetadataClient.getToken();
		if (token) {
			this.userId = token.userId;
			this.userName(token.userName);
			this.isTwoFactorAuthenticated(token.isTwoFactor === "false" ? false : true);
			this.accountName(token.accountName);
			this._fullName = _.isEmpty(token.userFullName) ? token.userName : token.userFullName;
			if (token.invalidLicense === undefined || token.invalidLicense === null) {
				this.logout();
				return false;
			}
			this.invalidLicenseReason = InvalidLicenseReason[token.invalidLicense.toString()];
			this.isLoggedIn(true);

			if (token.initialRecharge === 'true') {
				return false;
			}
			this.email(token.userEmail);
			// check for backward compatibility (existing tokens)
			if (token.userLanguage) {
				ApplicationConfig.language(token.userLanguage);
			}

			if (token.isRightToLeftLanguage === 'true') {
				ApplicationConfig.isRightToLeftLanguage(true);
			} else {
				ApplicationConfig.isRightToLeftLanguage(false);
			}
            this.isActiveDirectory(token.isActiveDirectory === 'true');
            this.isFusionServerEnabled(token.isFusionServerEnabled === 'true');
            this.hasProLicense(token.professionalLicense == 'true');

			return true;
		} else {
			this.logout();
		}

		return false;
	}
}
